"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLACEHOLDER_UNDEFINED = exports.PACKAGE_NAME = void 0;
exports.PACKAGE_NAME = 'redux-deep-persist';
exports.PLACEHOLDER_UNDEFINED = '@@placeholder/undefined';
//# sourceMappingURL=constants.js.map